import jbs_api from "@/modules/jbs-api";

export default {
  namespaced: true,
  state: {
    is_approved: false,
    is_email_confirmed: false,
    is_guest: true,
    is_reauthed: false,
    is_staff: false,
    user_login: "Guest",
    customer_name: "",
    address_book: false,
    customers: [],
    defaults: []
  },
  getters: {},
  mutations: {
    update(state, payload) {
      for (var k in payload) {
        state[k] = payload[k];
      }
    }
  },
  actions: {
    register(context, payload) {
      return jbs_api.post("User", payload);
    },
    login(context, payload) {
      if (process.env.JBS_SITEMODE === "trade") {
        context.commit("winelist/reset_active_list");
      }
      return jbs_api.post("Login", payload);
    },
    lookup_postcode(context, payload) {
      return jbs_api.get("AddressLookup", { params: { PostCode: payload } });
    },
    create_address(context, payload) {
      return jbs_api.post("AddressBook", payload).then(function(response) {
        let address_book = response.data;
        context.commit("update", { address_book });
      });
    },
    update_address(context, payload) {
      return jbs_api.put("AddressBook", payload).then(function(response) {
        let address_book = response.data;
        context.commit("update", { address_book });
      });
    },
    load_address_book(context) {
      return jbs_api.get("AddressBook").then(function(response) {
        context.commit("update", {
          address_book: response.data.address_book,
          default_addresses: response.data.default_addresses
        });
        context.commit("readiness/is_ready", "address_book", { root: true });
      });
    }
  }
};
